import moment from "moment";
export class StaffProbationHdr {
  StaffID;
  DateInt;
  Rem;
  PorbResult;
  DateEff;
  MonthExtend;
  MonthExtendDate;
  AddBy;
  ModifyBy;
  StaffProbationDtlList;
  constructor() {
    this.StaffID = "";
    this.DateInt = "";
    this.Rem = "";
    this.PorbResult = "";
    this.DateEff = "";
    this.MonthExtendDate = moment().format("YYYY-MM-DD");
    this.MonthExtend = "";
    this.AddBy = "";
    this.ModifyBy = "";
    this.StaffProbationDtlList = [];
  }
}



// WEBPACK FOOTER //
// ./src/model/StaffProbationHdr.js